/**
 * Resolves the `contentId` for a journal article.
 *
 * The route segment repeats across journals, volumes and issues, so use the
 * full article path, which includes the journal, volume and issue.
 *
 * Returns an empty string while the article is loading. Tracking skips empty
 * ids, so no event is emitted before the real id is available.
 */
export function trackableJournalArticleId(articleId: string | null | undefined): string {
  return articleId?.trim() ?? ''
}
